export const documentFiles = "/documentFiles/files";

export const signatureFiles = "/documentFiles/signatures";
